import Http from "../services/Providers/Http";

const ENDPOINTS = {
  LOGIN: "/api/auth/login",
  UPDATE: "/api/auth/update",
  RENEW: "/api/auth/renewtoken",
  LOGIN_PERSON: "/api/auth/loginForPerson",
  LOGIN_STUDENT: "/api/auth/loginForStudent",
  LOGIN_TUMER: "/api/auth/loginForTumer",
  LOGIN_GRADUATE: "/api/auth/loginForGraduate",
  LOGIN_STUDENT_WITHOUT_PASSWORD: "/api/auth/loginForStudentWithoutPassword",
  LOGIN_SMS_VERIFY: "/api/auth/loginSmsVerify",
  FORGOT_PASSWORD: "/api/auth/forgotPassword",
  FORGOT_SMS_VERIFY: "/api/auth/forgotSmsVerify",
  NEW_PASSWORD: "/api/auth/newPassword",
  NEW_PASSWORD_OLD: "/api/auth/newPasswordOld",
  FORGOT_PASSWORD_FOR_STUDENT: "/api/auth/forgotPasswordForStudent",
  FORGOT_SMS_VERIFY_FOR_STUDENT: "/api/auth/forgotSmsVerifyForStudent",
  NEW_PASSWORD_FOR_STUDENT: "/api/auth/newPasswordForStudent",
  FIND_MAIL_FOR_STUDENT: "/api/auth/findMailForStudent",
  FIND_MAIL_SMS_VERIFY_FOR_STUDENT: "/api/auth/findSmsVerifyForStudent",
  GET_MY_USERS: "/api/auth/getMyUsers",
  GET_MY_USERS_FOR_STUDENT: "/api/auth/getMyUsersForStudent",
  GET_MY_USERS_FOR_TUMER: "/api/auth/getMyUsersForTumer",
  GET_MY_USERS_FOR_GRADUATE: "/api/auth/getMyUsersForGraduate",
  FIND_REFERRAL_URL: "/api/auth/findReferralUrl"
};

export default {
  login: (body, payload, params) => {
    return Http.post(ENDPOINTS.LOGIN, body, params, null, payload);
  },
  update: (body, payload, params) => {
    return Http.post(ENDPOINTS.UPDATE, body, params, null, payload);
  },
  gateway: (url, payload, params) => {
    return Http.get(url, params, [], payload);
  },
  renew: (body, payload, params) => {
    return Http.post(ENDPOINTS.RENEW, body, params, null, payload);
  },
  loginForPerson: (body, payload, params) => {
    return Http.post(ENDPOINTS.LOGIN_PERSON, body, params, null, payload);
  },
  loginForStudent: (body, payload, params) => {
    return Http.post(ENDPOINTS.LOGIN_STUDENT, body, params, null, payload);
  },
  loginForStudentWithoutPassword: (body, payload, params) => {
    return Http.post(ENDPOINTS.LOGIN_STUDENT_WITHOUT_PASSWORD, body, params, null, payload);
  },
  loginForTumer: (body, payload, params) => {
    return Http.post(ENDPOINTS.LOGIN_TUMER, body, params, null, payload);
  },
  loginForGraduate: (body, payload, params) => {
    return Http.post(ENDPOINTS.LOGIN_GRADUATE, body, params, null, payload);
  },
  loginSmsVerify: (body, payload, params) => {
    return Http.post(ENDPOINTS.LOGIN_SMS_VERIFY, body, params, null, payload);
  },
  getMyUsers: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_MY_USERS, body, params, null, payload);
  },
  getMyUsersForStudent: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_MY_USERS_FOR_STUDENT, body, params, null, payload);
  },
  getMyUsersForTumer: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_MY_USERS_FOR_TUMER, body, params, null, payload);
  },
  getMyUsersForGraduate: (body, payload, params) => {
    return Http.post(ENDPOINTS.GET_MY_USERS_FOR_GRADUATE, body, params, null, payload);
  },
  forgotPassword: (body, payload, params) => {
    return Http.post(ENDPOINTS.FORGOT_PASSWORD, body, params, null, payload);
  },
  newPassword: (body, payload, params) => {
    return Http.post(ENDPOINTS.NEW_PASSWORD, body, params, null, payload);
  },
  newPasswordOld: (body, payload, params) => {
    return Http.post(ENDPOINTS.NEW_PASSWORD_OLD, body, params, null, payload);
  },
  forgotSmsVerify: (body, payload, params) => {
    return Http.post(ENDPOINTS.FORGOT_SMS_VERIFY, body, params, null, payload);
  },
  forgotPasswordForStudent: (body, payload, params) => {
    return Http.post(ENDPOINTS.FORGOT_PASSWORD_FOR_STUDENT, body, params, null, payload);
  },
  newPasswordForStudent: (body, payload, params) => {
    return Http.post(ENDPOINTS.NEW_PASSWORD_FOR_STUDENT, body, params, null, payload);
  },
  forgotSmsVerifyForStudent: (body, payload, params) => {
    return Http.post(ENDPOINTS.FORGOT_SMS_VERIFY_FOR_STUDENT, body, params, null, payload);
  },
  findMailForStudent: (body, payload, params) => {
    return Http.post(ENDPOINTS.FIND_MAIL_FOR_STUDENT, body, params, null, payload);
  },
  findMailSmsVerifyForStudent: (body, payload, params) => {
    return Http.post(ENDPOINTS.FIND_MAIL_SMS_VERIFY_FOR_STUDENT, body, params, null, payload);
  },
  findReferralUrl: (body, payload, params) => {
    return Http.post(ENDPOINTS.FIND_REFERRAL_URL, body, params, null, payload);
  },
};
